<h1 mat-dialog-title>DELETE PROVIDER</h1>
<div mat-dialog-content>
  <p>You may need to reassign the songs of this provider to another. Would you continue?</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveProviderCancel()">CANCEL</button>
  <button mat-button (click)="removeProvider(provider)" cdkFocusInitial>YES</button>
</div>